export default __webpack_public_path__ + "static/media/mfi_post_ex_cross.50cf613f.svg";